function seconds(amount: number): number {
    return 1000 * amount
}

function minutes(amount: number): number {
    return seconds(60 * amount)
}

function hours(amount: number): number {
    return minutes(60 * amount)
}

export { seconds, minutes, hours }
